/* ============================================================================
 * eyeoo-banner-gallery-nav.js
 * Progetto: Comelstile (Avante 14.0) — network Eye-oo
 * ----------------------------------------------------------------------------
 * PROBLEMA
 * Nella Banner gallery le frecce saltano delle immagini. Misurato in pagina:
 * passo 5,06 card contro 3,33 card visibili — quasi due immagini per clic
 * non vengono mai mostrate.
 *
 * CAUSA
 * Doppia fonte di verita' sul numero di colonne. eyeoo-custom.css forza
 * --desktop-grid-type per allargare le foto, ma il JS del tema calcola il
 * passo dall'IMPOSTAZIONE della sezione, non misurando il DOM. Le card
 * diventano piu' larghe, il passo resta "cinque colonne": scorre di cinque
 * card della nuova larghezza.
 *
 * SOLUZIONE PREFERIBILE, SE POSSIBILE
 * Impostare le colonne desktop nei settaggi della sezione e rimuovere
 * l'override CSS. Cosi' CSS e JS leggono lo stesso numero, non serve
 * questo file, e non c'e' nulla da manutenere al prossimo aggiornamento
 * del tema. Questo modulo serve solo se quel settaggio non e' esposto o
 * non accetta il valore desiderato.
 *
 * COSA FA
 * Intercetta il clic sulle frecce e pagina lui, misurando la geometria
 * reale al momento del clic: porta in testa la prima card non
 * interamente visibile. Il passo coincide quindi per costruzione con
 * quanto si vede, e nessuna immagine puo' essere saltata — qualunque sia
 * la larghezza delle card, il gap o il numero di colonne.
 *
 * Additivo: nessuna modifica ai file del tema.
 * Caricare da eyeoo-assets.liquid dopo eyeoo-custom.js.
 * ========================================================================== */

(function () {
  'use strict';

  var CONFIG = {
    /* Ambito. La galleria personalizzata vive sui template pagina
       (classe emessa da eyeoo-assets.liquid). '' = tutte le gallerie. */
    scope: 'html.eyeoo-tpl-page',

    gallery: '.banner-gallery',
    card: '.banner-gallery__card',
    prev: '.slider-button--prev',
    next: '.slider-button--next',

    behavior: 'smooth',
    debug: false
  };

  function log() {
    if (CONFIG.debug && window.console) {
      console.log.apply(console, ['[eyeoo-gallery-nav]'].concat([].slice.call(arguments)));
    }
  }

  function reduceMotion() {
    return !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* --------------------------------------------------------------------
   * Geometria
   * ------------------------------------------------------------------ */

  /* Il contenitore che scorre davvero puo' essere la griglia o un
     viewport intermedio, a seconda del layout scelto nella sezione: si
     rileva invece di assumerlo. */
  function scrollerOf(gallery) {
    var candidates = gallery.querySelectorAll('*');

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var overflow = window.getComputedStyle(el).overflowX;
      if (overflow !== 'auto' && overflow !== 'scroll') continue;
      if (el.scrollWidth - el.clientWidth > 2) return el;
    }

    return null;
  }

  /* Posizione di una card nel sistema di coordinate dello scroller,
     indipendente da offsetParent e da eventuali padding. */
  function startOf(card, scrollerRect, scrollLeft) {
    return card.getBoundingClientRect().left - scrollerRect.left + scrollLeft;
  }

  function page(scroller, cards, direction) {
    var rect = scroller.getBoundingClientRect();
    var left = scroller.scrollLeft;
    var width = scroller.clientWidth;
    var max = scroller.scrollWidth - width;

    var starts = [];
    var widths = [];
    for (var i = 0; i < cards.length; i++) {
      starts.push(startOf(cards[i], rect, left));
      widths.push(cards[i].getBoundingClientRect().width);
    }

    var target = null;
    var j;

    if (direction > 0) {
      /* Prima card che NON entra interamente nella vista: diventa la
         prima a sinistra. Il passo e' quindi sempre <= quanto si vede. */
      for (j = 0; j < starts.length; j++) {
        if (starts[j] + widths[j] > left + width + 1) {
          target = starts[j];
          break;
        }
      }
      /* Nessuna card oltre il bordo: si e' in fondo. */
      if (target === null) target = max;
    } else {
      /* Indietro di una vista, allineando comunque a inizio card. */
      var wanted = left - width;
      for (j = starts.length - 1; j >= 0; j--) {
        if (starts[j] <= wanted + 1) {
          target = starts[j];
          break;
        }
      }
      if (target === null) target = 0;
    }

    target = Math.max(0, Math.min(Math.round(target), Math.round(max)));

    log('da', Math.round(left), 'a', target,
        '| vista', Math.round(width), '| card', cards.length);

    scroller.scrollTo({
      left: target,
      top: scroller.scrollTop,
      behavior: reduceMotion() ? 'auto' : CONFIG.behavior
    });
  }

  /* --------------------------------------------------------------------
   * Aggancio
   * ------------------------------------------------------------------ */

  function onClick(event) {
    if (event.defaultPrevented || event.button !== 0) return;

    var target = event.target;
    if (!target || !target.closest) return;

    var button = target.closest(CONFIG.prev + ', ' + CONFIG.next);
    if (!button) return;
    if (button.hasAttribute('disabled')) return;

    var gallery = button.closest(CONFIG.gallery);
    if (!gallery) return;
    if (CONFIG.scope && !document.querySelector(CONFIG.scope)) return;

    var scroller = scrollerOf(gallery);
    if (!scroller) return;

    var cards = gallery.querySelectorAll(CONFIG.card);
    if (cards.length < 2) return;

    /* Capture su window: si arriva prima del gestore del tema, che
       altrimenti scorrerebbe col proprio passo sbagliato. Bloccare la
       propagazione evita due animazioni concorrenti. */
    event.preventDefault();
    event.stopPropagation();

    page(scroller, cards, button.matches(CONFIG.next) ? 1 : -1);
  }

  function init() {
    window.addEventListener('click', onClick, true);

    if (window.EYEOO) {
      window.EYEOO.bannerGalleryNav = { page: page, scrollerOf: scrollerOf, config: CONFIG };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();